export const faqData = {
  fr: [
    {
      category: "Général",
      questions: [
        {
          q: "Qu'est-ce que JoSmart ?",
          a: "JoSmart est une entreprise de développement de solutions digitales. Nous créons des applications mobiles, des sites web, des plateformes SaaS et des solutions d'automatisation avec intelligence artificielle pour aider les entreprises à se digitaliser."
        },
        {
          q: "Quels types de services proposez-vous ?",
          a: "Nous proposons le développement d'applications mobiles (Android/iOS), de sites web, de plateformes web complexes, de solutions SaaS, d'automatisation de processus et d'intégration d'intelligence artificielle."
        },
        {
          q: "Dans quels pays travaillez-vous ?",
          a: "Nous travaillons avec des clients du monde entier. Grâce aux outils de communication modernes, nous pouvons collaborer efficacement peu importe votre localisation géographique."
        },
        {
          q: "Quelles sont vos heures de travail ?",
          a: "Notre équipe est disponible du lundi au vendredi, de 9h à 18h. Pour les urgences, nous offrons un support 24/7 via WhatsApp pour nos clients actifs."
        }
      ]
    },
    {
      category: "Projets & Développement",
      questions: [
        {
          q: "Comment démarre un projet avec JoSmart ?",
          a: "Tout commence par une consultation gratuite où nous analysons vos besoins. Ensuite, nous proposons une solution adaptée avec un devis détaillé. Une fois validé, nous passons au développement avec des points réguliers."
        },
        {
          q: "Combien de temps prend le développement d'une application ?",
          a: "Le délai varie selon la complexité. Une application simple peut prendre 4-6 semaines, tandis qu'une plateforme complexe peut nécessiter 3-6 mois. Nous vous donnons une estimation précise après analyse de votre projet."
        },
        {
          q: "Est-ce que je garde le contrôle de mon application ?",
          a: "Absolument ! Vous êtes propriétaire à 100% de votre code source, de vos données et de votre hébergement. Nous vous donnons toutes les clés pour être totalement indépendant."
        },
        {
          q: "Proposez-vous la maintenance après le lancement ?",
          a: "Oui, nous offrons des contrats de maintenance mensuelle qui incluent les mises à jour de sécurité, les corrections de bugs et l'assistance technique. Les tarifs dépendent de la taille de votre projet."
        },
        {
          q: "Puis-je suivre l'avancement de mon projet ?",
          a: "Bien sûr ! Nous organisons des réunions hebdomadaires et vous avez accès à un tableau de bord de suivi en temps réel. La transparence est une de nos valeurs fondamentales."
        }
      ]
    },
    {
      category: "Tarification & Paiement",
      questions: [
        {
          q: "Comment sont calculés vos tarifs ?",
          a: "Nos tarifs sont basés sur la complexité du projet, les fonctionnalités demandées et le délai souhaité. Nous proposons toujours un devis détaillé gratuit avant de commencer."
        },
        {
          q: "Quels modes de paiement acceptez-vous ?",
          a: "Nous acceptons les virements bancaires, PayPal, et les paiements par carte. Pour les gros projets, nous proposons un échéancier de paiement en plusieurs fois."
        },
        {
          q: "Y a-t-il des frais cachés ?",
          a: "Non, jamais. Tout est détaillé dans le devis initial. Si des modifications sont demandées en cours de projet, nous vous informons immédiatement du coût supplémentaire éventuel."
        },
        {
          q: "Proposez-vous des forfaits ?",
          a: "Oui, nous avons des forfaits pour les sites vitrines, les applications standard et les solutions e-commerce. Contactez-nous pour obtenir nos grilles tarifaires."
        }
      ]
    },
    {
      category: "JoSmart Chat",
      questions: [
        {
          q: "Qu'est-ce que JoSmart Chat ?",
          a: "JoSmart Chat est notre application phare de messagerie nouvelle génération. Elle combine communication instantanée, réseau social et intelligence artificielle dans une seule application."
        },
        {
          q: "Quelles sont les fonctionnalités de JoSmart Chat ?",
          a: "JoSmart Chat offre : messagerie instantanée, appels audio, fil d'actualité social, statuts éphémères 24h, assistant IA (JoChat AI), traduction automatique français/anglais, et badges de vérification."
        },
        {
          q: "JoSmart Chat est-il gratuit ?",
          a: "Oui, JoSmart Chat est totalement gratuit à télécharger et à utiliser. Certaines fonctionnalités premium pourront être proposées dans le futur."
        },
        {
          q: "Sur quelles plateformes JoSmart Chat est-il disponible ?",
          a: "Actuellement, JoSmart Chat est disponible sur Android via Google Play Store. La version iOS est en développement et sera disponible prochainement."
        },
        {
          q: "Comment fonctionne la traduction automatique ?",
          a: "Notre IA traduit automatiquement vos messages du français vers l'anglais et vice versa, permettant de communiquer sans barrière linguistique avec des utilisateurs du monde entier."
        },
        {
          q: "Mes données sont-elles sécurisées sur JoSmart Chat ?",
          a: "Absolument. Nous utilisons un chiffrement de bout en bout pour les messages, et vos données personnelles sont protégées conformément aux normes de sécurité les plus strictes."
        }
      ]
    },
    {
      category: "Support & Contact",
      questions: [
        {
          q: "Comment puis-je vous contacter ?",
          a: "Vous pouvez nous contacter via WhatsApp au +14313345083, par email à contactjosmart1@gmail.com, ou en remplissant le formulaire de contact sur notre site."
        },
        {
          q: "Quel est votre délai de réponse ?",
          a: "Nous répondons généralement dans les 24 heures ouvrées. Pour les urgences, utilisez WhatsApp pour une réponse plus rapide."
        },
        {
          q: "Proposez-vous des consultations gratuites ?",
          a: "Oui ! La première consultation pour analyser votre projet est totalement gratuite et sans engagement. Contactez-nous pour planifier un rendez-vous."
        }
      ]
    }
  ],
  en: [
    {
      category: "General",
      questions: [
        {
          q: "What is JoSmart?",
          a: "JoSmart is a digital solutions development company. We create mobile applications, websites, SaaS platforms and automation solutions with artificial intelligence to help businesses digitalize."
        },
        {
          q: "What types of services do you offer?",
          a: "We offer mobile application development (Android/iOS), websites, complex web platforms, SaaS solutions, process automation and artificial intelligence integration."
        },
        {
          q: "In which countries do you work?",
          a: "We work with clients from all over the world. Thanks to modern communication tools, we can collaborate effectively regardless of your geographic location."
        },
        {
          q: "What are your working hours?",
          a: "Our team is available Monday to Friday, 9am to 6pm. For emergencies, we offer 24/7 support via WhatsApp for our active clients."
        }
      ]
    },
    {
      category: "Projects & Development",
      questions: [
        {
          q: "How does a project start with JoSmart?",
          a: "Everything starts with a free consultation where we analyze your needs. Then, we propose a suitable solution with a detailed quote. Once validated, we move to development with regular check-ins."
        },
        {
          q: "How long does application development take?",
          a: "The timeline varies depending on complexity. A simple application can take 4-6 weeks, while a complex platform may require 3-6 months. We give you a precise estimate after analyzing your project."
        },
        {
          q: "Do I keep control of my application?",
          a: "Absolutely! You own 100% of your source code, data and hosting. We give you all the keys to be totally independent."
        },
        {
          q: "Do you offer maintenance after launch?",
          a: "Yes, we offer monthly maintenance contracts that include security updates, bug fixes and technical assistance. Rates depend on the size of your project."
        },
        {
          q: "Can I track my project progress?",
          a: "Of course! We organize weekly meetings and you have access to a real-time tracking dashboard. Transparency is one of our core values."
        }
      ]
    },
    {
      category: "Pricing & Payment",
      questions: [
        {
          q: "How are your rates calculated?",
          a: "Our rates are based on project complexity, requested features and desired timeline. We always provide a free detailed quote before starting."
        },
        {
          q: "What payment methods do you accept?",
          a: "We accept bank transfers, PayPal, and card payments. For large projects, we offer a payment schedule in several installments."
        },
        {
          q: "Are there any hidden fees?",
          a: "No, never. Everything is detailed in the initial quote. If modifications are requested during the project, we immediately inform you of any additional cost."
        },
        {
          q: "Do you offer packages?",
          a: "Yes, we have packages for showcase websites, standard applications and e-commerce solutions. Contact us to get our pricing grids."
        }
      ]
    },
    {
      category: "JoSmart Chat",
      questions: [
        {
          q: "What is JoSmart Chat?",
          a: "JoSmart Chat is our flagship next-generation messaging application. It combines instant communication, social networking and artificial intelligence in one application."
        },
        {
          q: "What are the features of JoSmart Chat?",
          a: "JoSmart Chat offers: instant messaging, audio calls, social news feed, 24h ephemeral statuses, AI assistant (JoChat AI), automatic French/English translation, and verification badges."
        },
        {
          q: "Is JoSmart Chat free?",
          a: "Yes, JoSmart Chat is completely free to download and use. Some premium features may be offered in the future."
        },
        {
          q: "On which platforms is JoSmart Chat available?",
          a: "Currently, JoSmart Chat is available on Android via Google Play Store. The iOS version is in development and will be available soon."
        },
        {
          q: "How does automatic translation work?",
          a: "Our AI automatically translates your messages from French to English and vice versa, allowing you to communicate without language barriers with users from around the world."
        },
        {
          q: "Is my data secure on JoSmart Chat?",
          a: "Absolutely. We use end-to-end encryption for messages, and your personal data is protected in accordance with the strictest security standards."
        }
      ]
    },
    {
      category: "Support & Contact",
      questions: [
        {
          q: "How can I contact you?",
          a: "You can contact us via WhatsApp at +14313345083, by email at contactjosmart1@gmail.com, or by filling out the contact form on our website."
        },
        {
          q: "What is your response time?",
          a: "We generally respond within 24 business hours. For emergencies, use WhatsApp for a faster response."
        },
        {
          q: "Do you offer free consultations?",
          a: "Yes! The first consultation to analyze your project is completely free and without obligation. Contact us to schedule an appointment."
        }
      ]
    }
  ]
};

export default faqData;
